import React,
{
  forwardRef,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import Select from 'react-select';
import { flowType } from '@utility/userInfo';

  const defaultCustomStyles = ( serverAppTheme, isMenuOpen) => ({
  control: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
    height: '100%',
    fontSize: '14px',
    backgroundColor:serverAppTheme?.selector_control_color,
    borderRadius: state.isFocused ? "4px 4px 0 0" : 3,
    border:serverAppTheme?.popupBorder,
    ':hover': {
      border:serverAppTheme?.popupBorder
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    fontSize: '14px',
    justifyContent: 'left',
  }),
  placeholder: (provided) => ({
    ...provided,
    color:serverAppTheme?.primary_text,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color:serverAppTheme?.primary_text,
    ':hover': {
      color:serverAppTheme?.primary_text,
    },
    transition: 'transform 0.2s',
    transform: isMenuOpen ? 'rotate(180deg)' : null
  }),
  singleValue: (provided) => ({
    ...provided,
    maxWidth: '100%',
    textOverflow: 'unset',
    fontSize: flowType() === 'kiosk' || flowType() === 'paymentTerminal' ? '2vw' : '14px',
    color:serverAppTheme?.primary_text,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    display: flowType() === 'kiosk' ? 'none' : 'flex',
    color:'white',
  }),
  menuList: base => ({
    ...base,
    padding: 0,
    borderBottomLeftRadius:"4px",
    borderBottomRightRadius:"4px",
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    borderBottomLeftRadius:"4px",
    borderBottomRightRadius:"4px",
    marginTop: 0,
    backgroundColor:  serverAppTheme?.card_bg,
    border:serverAppTheme?.popupBorder
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
    fontSize: flowType() === 'kiosk' || flowType() === 'paymentTerminal' ? '2vw' : '14px',
    textAlign: 'left',
    backgroundColor: state.isSelected ? serverAppTheme?.drop_down_selected : serverAppTheme?.card_bg,//'rgb(47,47,47)',
    height: '100%',
    color: serverAppTheme?.primary_text,
    '&:active': {
      color: 'grey',
      backgroundColor: serverAppTheme?.drop_down_selected,
    }
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  })
});

const SimpleReactSelect = forwardRef((props, ref) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const selectRef = useRef(null);
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => {
        return selectRef.current.state.value;
      }
    }),
    []
  );
  const {
    name,
    id,
    options,
    placeholder,
    isMulti,
    isDisabled,
    isClearable,
    maxMenuHeight,
    // isSearchable,
    className,
    onChange,
    customLabel,
    onSelect = () => {},
    customId,
    defaultValue,
    serverAppTheme
  } = props;

  const defaultSort = options.sort((x, y) => {
    if (x.id === options.filter((item) => item.id === defaultValue)[0]?.id) return -1;
    if (y.id === options.filter((item) => item.id === defaultValue)[0]?.id) return 1;
    return 0;
  });
  return (
    <Select
      name={name}
      isDisabled={isDisabled}
      isSearchable={false}
      placeholder={placeholder}
      className={className}
      isMulti={isMulti}
      maxMenuHeight={maxMenuHeight}
      isClearable={isClearable}
      options={onSelect ? defaultSort : options}
      id={id}
      ref={selectRef}
      blurInputOnSelect
      getOptionLabel={(option) => { return customLabel ? option[customLabel] : option.name; }}
      getOptionValue={(option) => { return customId ? option[customId] : option.id; }}
      onChange={(data) => { if (onChange) onChange(data); }}
      value={options.filter((item) => item.id === defaultValue)[0]}
      styles={defaultCustomStyles(serverAppTheme, isMenuOpen)}
      onFocus={() => onSelect()}
      setImenuIsOpen={isMenuOpen}
      onMenuOpen={() => setIsMenuOpen(true)}
      onMenuClose={() => setIsMenuOpen(false)}
      theme={(theme) => ({
        ...theme,
        borderRadius: '3px',
        borderWidth: '2px',
        borderColor: 'rgba(173, 0, 40, 0.25)',
        boxShadow: '0 0 0 0.2rem rgba(173, 0, 40, 0.25)',
        colors: {
          ...theme.colors,
          primary: 'rgb(75,75,75)',
        },
      })}
    />
  );
});
export default SimpleReactSelect;
